import React from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import type { OnApproveData } from '@paypal/paypal-js';

interface PayPalCheckoutButtonsProps {
  amount: string;
  currency: string;
  onSuccess: (details: any) => void;
  onError: (error: any) => void;
  onCancel?: (data: any) => void;
}

const PayPalCheckoutButtons: React.FC<PayPalCheckoutButtonsProps> = ({ amount, currency, onSuccess, onError, onCancel }) => {
  const createOrder = (_data: Record<string, unknown>, actions: any) =>
    actions.order.create({
      purchase_units: [{ amount: { value: amount, currency_code: currency } }],
    });

  // Don't capture client-side — pass the orderID to the backend which captures and credits
  const onApprove = async (data: OnApproveData) => {
    onSuccess({ id: data.orderID, orderID: data.orderID });
  };

  return (
    <PayPalButtons
      style={{ layout: 'vertical' }}
      createOrder={createOrder}
      onApprove={onApprove}
      onError={onError}
      onCancel={onCancel}
    />
  );
};

export default PayPalCheckoutButtons;
